// extracted by mini-css-extract-plugin
export default {"shortDescriptionEditor":"ShortDescription-module__shortDescriptionEditor__rD_Qw"};